import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js';

const skioCartStyles = css`
  /* Existing Styles */
  :host {
    font-size: 15px;
  }

  /* Toggle Switch Styles */
  .subscription-toggle {
    width: 250px;
    display: flex;
    flex-wrap: nowrap;
  }
  .switch {
    position: relative;
    display: inline-block;
    width: 28px;
    height: 16px;
    margin-right: 6px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #BCBCBC;
    transition: 0.4s;
    border-radius: 34px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 12px;
    width: 12px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    -webkit-filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.25));
    filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.25));
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #93D500; /* Green when subscribed */
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #93D500;
  }

  input:checked + .slider:before {
    transform: translateX(12px);
  }

  /* Label Styles */
  .toggle-container {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .toggle-label {
    font-size: 16px;
    line-height: 20px;
    margin-top: -2px;
    color: #000;
  }

  /* Optional: Transition for smooth color change */
  .slider {
    transition: background-color 0.4s;
  }

  .swatch-sub {
  margin-right:4px;
  background-image: url("https://cdn.shopify.com/s/files/1/1344/2301/files/tick-circle.svg?v=1750350741");
  background-repeat: no-repeat;
  background-size: 16px;
  padding-bottom:20px;
  padding-left:18px;
}


  @media (max-width: 768px) {
    .toggle-label {
      font-size: 14px;
      line-height: 26px;
    }
  }
`;

export class SkioCartOptions extends LitElement {
  static styles = skioCartStyles;

  static properties = {
    item: { type: Object },
    line: { type: Number },
    product: { type: Object },
    selectedVariant: { type: Object },
    key: { type: String },
    skioSellingPlanGroups: { type: Array },
    availableSellingPlanGroups: { type: Array },
    selectedSellingPlanGroup: { type: Object },
    selectedSellingPlan: { type: Object },
    discount_format: { type: String },
    moneyFormatter: { type: Object },
    currency: { type: String }
  };

  constructor() {
    super();

    this.item = null;
    this.line = null;
    this.product = null;
    this.selectedVariant = null;
    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];
    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;
    this.discountFormat = 'percent';
    this.currency = 'USD';
    this.moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: this.currency,
    });
  }

  handleToggle(event) {
    const isSubscribed = event.target.checked;

    // Disable the toggle to prevent multiple clicks
    event.target.disabled = true;

    if (isSubscribed) {
      // User is opting into a subscription
      this.subscribeItem()
        .finally(() => {
          // Re-enable the toggle after operation completes
          event.target.disabled = false;
        });
    } else {
      // User is opting out of the subscription
      this.unsubscribeItem()
        .finally(() => {
          // Re-enable the toggle after operation completes
          event.target.disabled = false;
        });
    }
  }

  subscribeItem() {
    return new Promise((resolve, reject) => {
      // Fetch available selling plans and subscribe the item
      if (this.availableSellingPlanGroups && this.availableSellingPlanGroups.length > 0) {
        const defaultPlan = this.availableSellingPlanGroups[0].selling_plans[0];
        this.selectSellingPlan(defaultPlan.id)
          .then(resolve)
          .catch(reject);
      } else {
        this.error('No available subscription plans found.');
        reject('No available subscription plans found.');
      }
    });
  }

  unsubscribeItem() {
    return new Promise((resolve, reject) => {
      // Remove the selling plan from the cart item by setting it to null
      const data = JSON.stringify({
        line: this.line,
        quantity: this.item.quantity,
        selling_plan: null
      });

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: data
      })
      .then(response => response.json())
      .then(cart => {
        // Refresh the cart view
        Shopify.theme.jsAjaxCart.updateView();
        if (Shopify.theme.jsCart) {
          $.ajax({
            dataType: "json",
            async: false,
            cache: false,
            dataType: 'html',
            url: "/cart",
            success: function (html) {
              const cartForm = $(html).find('.cart__form');
              $('.cart__form').replaceWith(cartForm);
            }
          });
        }
        resolve(cart);
      })
      .catch(error => {
        this.error('Error unsubscribing:', error);
        alert('There was an error updating your subscription. Please try again.');
        reject(error);
      });
    });
  }

  render() {
  console.log('Rendering SkioCartOptions with:', {
    item: this.item,
    product: this.product,
    selectedVariant: this.selectedVariant,
    skioSellingPlanGroups: this.skioSellingPlanGroups
  });

  // Bail out if data is missing
  if (!this.item) {
    return html``;
  }

  // Render only if this line item is subscribed
  if (this.item.selling_plan_allocation) {
    return html`
      <div class="subscription-badge">
        <span class="swatch-sub"></span>
        <span class="toggle-label">Subscribe & Save</span>
      </div>
    `;
  }

  // Otherwise, render nothing
  return html``;
}

  updated(changed) {
    if (changed.has('item') && this.item) {
      this.fetchProduct(this.item.handle);
    }

    if (changed.has('product') && this.product) {
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      );

      console.log('skioSellingPlanGroups:', this.skioSellingPlanGroups);

      this.selectedVariant = this.product.variants.find(
        variant => variant.id == this.item.variant_id
      );

      if (this.item.selling_plan_allocation) {
        let itemSellingPlanId = this.item.selling_plan_allocation.selling_plan.id;

        this.selectedSellingPlanGroup = this.skioSellingPlanGroups.find(group =>
          group.selling_plans.find(selling_plan => selling_plan.id == itemSellingPlanId)
        );
        this.selectedSellingPlan = this.selectedSellingPlanGroup.selling_plans.find(
          selling_plan => selling_plan.id == itemSellingPlanId
        );
      }
    }

    if (changed.has('selectedVariant') && this.selectedVariant) {
      // Update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      );

      // Update selectedSellingPlan value
      if (this.availableSellingPlanGroups.length) {
        // Update each group with a default selected_selling_plan
        this.availableSellingPlanGroups.forEach(group => {
          group.selected_selling_plan = group.selling_plans[0];
        });
      }
    }
  }

  log(...args) {
    args.unshift('%c[skio cart options]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error(...args) {
    args.unshift('%c [skio cart options]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLineItem() {    
    if (!this.line || !this.item) return;
    
    const newSellingPlanId = this.selectedSellingPlan ? this.selectedSellingPlan.id : null;

    if (this.item.selling_plan_allocation?.selling_plan?.id === newSellingPlanId) return;

    const data = JSON.stringify({
      line: this.line,
      quantity: this.item.quantity,
      selling_plan: newSellingPlanId,
      // Remove these two lines if the cart doesn't use the section rendering API
      // sections: this.getSectionsToRender().map((section) => section.section),
      // sections_url: window.location.pathname
    });

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: data
    })
    .then((response) => response.json())
    .then((cart) => {
      // Refresh the cart view
      Shopify.theme.jsAjaxCart.updateView();
      if (Shopify.theme.jsCart) {
        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          dataType: 'html',
          url: "/cart",
          success: function (html) {
            const cartForm = $(html).find('.cart__form');
            $('.cart__form').replaceWith(cartForm);
          }
        });
      }
    })
    .catch(error => {
      this.error('Error updating line item:', error);
      alert('There was an error updating your subscription. Please try again.');
    });
  }

  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(id) {
    return new Promise((resolve, reject) => {
      if (!id) {
        this.selectedSellingPlanGroup = null;
        this.selectedSellingPlan = null;
        
        this.updateLineItem();
        resolve();
        return;
      }

      let group = this.availableSellingPlanGroups.find(group =>
        group.selling_plans.find(selling_plan => selling_plan.id == id)
      );
      let selling_plan = group.selling_plans.find(x => x.id == id);
      
      if (selling_plan) {
        group.selected_selling_plan = selling_plan;
        this.selectedSellingPlanGroup = group;
        this.selectedSellingPlan = selling_plan;
      }
      else {
        this.log("Error: couldn't find selling plan with id " + id + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
        reject("Selling plan not found");
        return;
      }

      this.updateLineItem();
      resolve();
    });
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }
    
    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;
    
    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (price * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) /
            price) *
            100.0
        )}%`
        discount.amount = price - price_adjustment.value
        break
    }
    
    return discount
  }

  fetchProduct = async(handle) => {
    console.log('Fetching product with handle:', handle);
    let productCache = window.sessionStorage.skioCartProductCache
      ? JSON.parse(window.sessionStorage.skioCartProductCache)
      : [];
    let cachedProduct = productCache
      ? productCache.find(product => product.handle == handle)
      : null;
    
    if (cachedProduct) {
      this.product = cachedProduct;
    } else {
      await fetch(`/products/${handle}.js`)
        .then((response) => response.json())
        .then((response) => {
          this.product = response;
          productCache.push(response);
          window.sessionStorage.skioCartProductCache = JSON.stringify(productCache);
        })
        .catch(error => {
          this.error('Error fetching product data:', error);
        });
    }

    console.log('Fetched product data:', this.product);
  }
}

customElements.define('skio-cart-options', SkioCartOptions);
